// The request kinds the owner "Requests" view (RequestsHub) actually renders. The sidebar badge
// must count exactly these — the spine's `/provider/activity` also carries `ambulance` (a business
// the shop may provide) and, for workers, `service_request`, neither of which the Requests view
// shows. Counting those made the badge disagree with the list it links to (F-15).
export const REQUEST_SOURCE_TYPES = ["order", "appointment", "booking", "table_reservation"];

/** R8-2: ONE predicate for "waiting on the owner". The server decides it
 * (`core.enums.is_waiting_on_owner`, sent as `waiting_on_owner` on every `/provider/activity` row) so
 * web, the app and the console manifest cannot disagree: a stay/hall booking waits while `reserved`
 * (UI "Requested"); once `confirmed` (UI "Reserved") it is still open work but nobody is waiting. */
export const isWaitingOnOwner = (row) => row?.waiting_on_owner === true;

/** How many of `openActivity` are requests the Requests view shows AND the owner has yet to decide. */
export function requestsBadgeCount(openActivity) {
  return (openActivity || []).filter((a) => REQUEST_SOURCE_TYPES.includes(a.source_type) && isWaitingOnOwner(a)).length;
}

// R4-3: ONE booking/order status source of truth. The activity spine folds every lifecycle onto a
// coarse shared `status` (a reserved stay reads "requested"), while the real state lives in
// `source_status`. Anything that names an item's state to the citizen - the home resume card, the
// activity list, the detail page - must read the SAME per-lifecycle label, so derive it from the
// source status through the same `*.statusLabels` dictionaries those pages use.
const SOURCE_LABELS = {
  order: "commerce.statusLabels",
  appointment: "appointments.statusLabels",
  booking: "bookings.statusLabels",
  table_reservation: "tables.statusLabels",
  service_request: "tasks.statusLabels",
  ambulance: "ambulance.statusLabels",
};

/** The per-lifecycle label for a row from its REAL source status (`bookings.statusLabels`, ...), or
 * null when the kind has no label dictionary. APP_RULES section 2: one status vocabulary per
 * object - derived from the object's state, never hard-coded per screen. */
export function sourceStatusLabel(t, item) {
  const labels = SOURCE_LABELS[item.source_type] ? t(SOURCE_LABELS[item.source_type]) : null;
  const real = item.source_status || item.status;
  return labels && typeof labels === "object" && labels[real] ? labels[real] : null;
}

/** The citizen-facing status label for one `/activity/mine` row. */
export function activityStatusLabel(t, item) {
  return sourceStatusLabel(t, item) || t(`activity.status.${item.status}`);
}
